import React, { Component } from 'react';
import { Container, Row, Col, FormControl, Image, Form, Button, Pagination, ButtonToolbar, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Bounce } from 'react-activity';
import { store } from 'react-notifications-component';

import NavbarComponent from '../../Navbar/index';
import RenovateTokenAlert from '../../../RenovateToken';
import Backend from '../../../Backend';
import Connection from '../../../Calls';

import EcommOptions from '../ecommOptions'

import InputFile from '../../KycForm/components/inputFile'
import ImgIDFront from '../../../Images/document-ID-front.png'

import './index.css'

class EcommerceConfig extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showLoad:false,
      coins_settings:{},
      list_banks:[],
      currency: "mxn",
      vex_fee: "1.0",
    }
  }

  componentWillMount(){
    this.getFeeVex()
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.client_banks_list(localStorage.getItem('email'), localStorage.getItem('token'), 'approved',response.payload.r01, response => {
          if(response.status.code == '0') this.setState({list_banks:response.payload.list_banks})
      });
    })
  }

  addNotification(status,msg,type){
      store.addNotification({
        title: status,
        message: msg,
        type: type,
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 2500,
          onScreen: true
        }
      });
  }

  getFeeVex () {
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.GroupInformationPlanInfo(localStorage.getItem('email'), localStorage.getItem('token'),response.payload.r01, response => {
        if(response.status.code === "0"){
          const {transaction_xchV_fee} = response.payload.plan
          this.setState({vex_fee: transaction_xchV_fee})
        }
      })
    })
  }

  createCommerce(){
    let { ecomm_name, wallet_pass_plain, ecomm_img, url} = this.state
    if(!ecomm_name || !wallet_pass_plain || !url || !ecomm_img) return

    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    let whiskas = Connection.RThzHrsb(wallet_pass_plain);
    let combination2 = Connection.RThzHrsb("XWBX203");
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });

    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      let EZcga8qH = response.payload.r01
       Connection.QCJQ7DUk(confirmation, date, result, "Apxm2aZ", combination2, "XWBX203", "2", whiskas, async response => {
        let wallet_pass = response.payload.r03

        let commercePromice = new Promise((resolve,reject)=> Backend.create_commerce(localStorage.getItem('email'), localStorage.getItem('token'), EZcga8qH, this.state, wallet_pass, resolve) )
        let commerceResponse = await commercePromice
        if(commerceResponse.status.code !== "0") return this.addNotification("Error!",'Something went wrong, try again later',"danger");

        Backend.upload_file(localStorage.getItem('email'), localStorage.getItem('token'),ecomm_img,'f_ecomm_logo',EZcga8qH, imageResponse =>{
          if(imageResponse.status.code !== "0") return this.addNotification("Error!",'File could not be uploaded, try again later',"danger");
        })

        localStorage.setItem('ecomm','true')
        this.props.data.history.push('/ecommerce')

      })
    });
  }

  disableButton(){
    let { showLoad, ecomm_name, wallet_pass_plain, ecomm_img, url } = this.state
    if(showLoad) return true
    if(!ecomm_name || !wallet_pass_plain || !url || !ecomm_img ) return true

    return false
  }

  optionStyle(state,id){
    if(state == id) return 'ecommerce_multi_option active'
    else return 'ecommerce_multi_option'
  }

  render(){
    let { ecomm } = this.props.traductions
    return(
      <div>
        <NavbarComponent data={this.props} selected="ecommerce" logged={true} />
        <RenovateTokenAlert data={this.props} />
        <div className="contenedor-wallets-generals" style={{ paddingLeft: 10, paddingRight: 10 }}>
          <Container className='ecommerce_signup'>
            <p>{ecomm.setup}</p>
            <div className='container-transactions'>
              <div style={{marginBottom:10}}>
                <Form.Label className="ecommerce_input_label">{ecomm.name}:</Form.Label>
                <Form.Control
                  style={{ height: 40 }}
                  className="ecommerce_input"
                  type="text"
                  placeholder="Name"
                  value={this.state.ecomm_name}
                  onChange={(ecomm_name) => { this.setState({ ecomm_name: ecomm_name.target.value }) }}
                  />
              </div>


              <div style={{marginBottom:10}}>
                <Form.Label className="ecommerce_input_label">URL:</Form.Label>
                <Form.Control
                  style={{ height: 40 }}
                  className="ecommerce_input"
                  type="text"
                  placeholder="https://www.myecommerce.com"
                  value={this.state.url}
                  onChange={(url) => { this.setState({ url: url.target.value }) }}
                  />
              </div>

              <div style={{marginBottom:10}}>
                <Form.Label className="ecommerce_input_label">{ecomm.image}:</Form.Label>
                <div className='ecommerce_image_input_container'>
                  <InputFile noPdf image={ImgIDFront} setImage={e => this.setState({ecomm_img:e})}/>
                </div>
              </div>

              <div className='ecommerce_divider'/>
              <p className="dark-text medium-dms">{ecomm.select_currency}</p>
              <div style={{display: 'flex'}}>
                <div onClick={()=> this.setState({currency: 'usd'})}
                  className={this.state.currency === 'usd' ? 'ecommerce_multi_option active': 'ecommerce_multi_option'}
                >
                  USD
                </div>

                <div
                style={{marginLeft: '20%'}}
                onClick={()=> this.setState({currency: 'mxn'})}
                className={this.state.currency === 'mxn' ? 'ecommerce_multi_option active': 'ecommerce_multi_option'}>
                  MXN
                </div>
              </div>
              <div className='ecommerce_divider'/>

              <p>{ecomm.trans_config}</p>

              <EcommOptions {...this.props} {...this.state} setState={this.setState.bind(this)} noBank={this.state.list_banks.length == 0}/>

              <div className='ecommerce_divider'/>

              <p>{ecomm.wallets}</p>

              <div style={{marginBottom:10}}>
                <Form.Label className="ecommerce_input_label">{ecomm.wallets_password}:</Form.Label>
                <Form.Control
                  style={{ height: 40 }}
                  className="ecommerce_input"
                  type="password"
                  placeholder="**********"
                  value={this.state.wallet_pass_plain}
                  onChange={(wallet_pass_plain) => { this.setState({ wallet_pass_plain: wallet_pass_plain.target.value }) }}
                  />
              </div>


              <Button className='ecommerce_signup_button medium-dms' disabled={this.disableButton()} onClick={()=>this.createCommerce()}>
                {
                  (this.state.showLoad)
                    ? <Bounce size={20} color={"#FFFFFF"} animating={this.state.showload} />
                    : 'Crear E-Commerce'
                }

              </Button>
            </div>
          </Container>
        </div>

      </div>
    )
  }

}
export default EcommerceConfig
